/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { BaseToken } from '../../baseToken.js';

/**
 * Common base token that all `markdown` tokens should
 * inherit from.
 */
export abstract class MarkdownToken extends BaseToken { }
